import {isObservableArray} from 'mobx';

export type Diff<T extends string, U extends string> = ({[P in T]: P} & {[P in U]: never} & {[x: string]: never})[T];
export type Omit<T, K extends Extract<keyof T, string>> = Pick<T, Diff<Extract<keyof T, string>, K>>;

export const isGeneralArray = (value: any): value is any[] => {
    return Array.isArray(value) || isObservableArray(value);
};

export const expectNever = (value: never) => {
    throw new Error('no value expected');
};



// WEBPACK FOOTER //
// ./src/types/Utility.ts